import api from './axiosConfig.js'

export const holidayApi = {
    // List holidays
    getHolidays: () =>
        api.get('/holidays/?skip=0&limit=100', {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),

    // Add new holiday
    addHoliday: (data) =>
        api.post('/holidays/create-holiday', data, {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),

    // Get holiday details
    getHolidayDetails: (id) =>
        api.get(`/holidays/get-holiday-details?holiday_id=${id}`, {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),

    // Update holiday
    updateHoliday: (id, data) =>
        api.put(`/holidays/update-holiday?holiday_id=${id}`, data, {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),

    // Delete holiday
    deleteHoliday: (id) =>
        api.delete(`/holidays/delete-holiday?holiday_id=${id}`, {
            headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),

    // Download holidays
    downloadHolidays: () =>
        api.get('/org/holidays/download', { responseType: 'blob' }),

    // Get upcoming holidays
    getUpcomingHolidays: () =>
        api.get('/attendance/summary/upcoming-holidays', {
             headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
        }),
}
